import {
  isActivityToDisplay,
  isRouteToDisplay,
  filterDepot,
} from '../../../../utils/map/MapFeatureFilters';


export function enhanceStopGeoJSONFeatures(geoJSON, display) {
  if (!geoJSON?.geo?.features) return geoJSON;

  const filteredFeatures = filterDepot(geoJSON, false);

  const stopFeatures = filteredFeatures.filter(
    (feature) =>
      feature.geometry.type === 'Point' &&
      !isActivityToDisplay(feature) &&
      isRouteToDisplay(feature, display),
  );

  return {
    ...geoJSON,
    geo: {
      ...geoJSON.geo,
      features: stopFeatures,
    },
  };
}
